import { PanelTrigger, SidePanelComponent } from '@digiwall/ui-kit';

export const paymentsSidePanelTrigger = (panel: SidePanelComponent) =>
  ({
    icon: 'digi-out-euro',
    panel,
    title: 'Doc::CustomerInvoice:Payments',
  }) as PanelTrigger;
